var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49 8.99C10.75 8.99 11.76 7.97 11.76 6.72C11.76 5.47 10.75 4.45 9.49 4.45C8.24 4.45 7.22 5.47 7.22 6.72C7.22 7.97 8.24 8.99 9.49 8.99Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95 12.63C5.39 13.44 6.05 14.13 6.85 14.61C7.65 15.09 8.56 15.34 9.49 15.35C10.42 15.34 11.33 15.09 12.13 14.61C12.93 14.13 13.59 13.44 14.04 12.63C14.01 10.9 11 9.9 9.49 9.9C7.98 9.9 4.97 10.9 4.95 12.63Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.5 1.54C4.83 1.54 1.04 5.33 1.04 10C1.04 14.67 4.83 18.46 9.5 18.46C14.17 18.46 17.96 14.67 17.96 10C17.96 5.33 14.17 1.54 9.5 1.54ZM-0.5 10C-0.5 4.48 3.98 0 9.5 0C15.02 0 19.5 4.48 19.5 10C19.5 15.52 15.02 20 9.5 20C3.98 20 -0.5 15.52 -0.5 10Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.b958d5e69897a066184c39eb416528ec.svg";
export { ForwardRef as ReactComponent };